<template>
  <div class="pt-10 pb-5 component-div">
    <!-- PREVIEW MODE -->
    <template v-if="mode == 0">
      <b-row>
        <b-col cols="12" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
          <div class="number-sequence">
            <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
            <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
          </div>
          <span
            class="ml-2 question-tital-name"
            v-translate:_formattedBody="{
              key: translationKeyInitial,
              val: lang,
              html: componentData.formattedBody
            }"
            v-html="componentData.formattedBody"
          ></span>
          <span
            class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2"
            v-if="componentData.isSkippable && (isFieldDisabled == false || isFieldDisabled == undefined)"
            v-translate:_optional="{
              key: 'label',
              val: lang,
              html: 'Optional'
            }"
            >Optional</span
          >
          <div v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">
            Skipped
          </div>
          <div class="ml-5" v-if="componentData && componentData.notifications && componentData.notifications.length > 0 && isNotificationIcon">
            <img alt="Bell icon" src="@/assets/NotificaionIcon.png" data-v-c76994f4 />
          </div>
        </b-col>
      </b-row>

      <b-row class="pl-45 pt-10">
        <table class="input-text" width="100%" border="1">
          <thead>
            <tr>
              <th
                class="text-center"
                v-for="(each, index) in componentData.entries"
                v-translate="{
                  key: `${translationKeyInitial}_entries_${index}_header`,
                  val: lang,
                  html: each.header
                }"
                :key="each.header"
              >
                {{ each.header }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                class="text-center"
                v-for="(each, index) in componentData.entries"
                v-translate="{
                  key: `${translationKeyInitial}_entries_${index}_label`,
                  val: lang,
                  html: each.label
                }"
                :key="each.label"
              >
                {{ each.label }}
              </td>
            </tr>
          </tbody>
        </table>
      </b-row>
    </template>

    <!-- EDIT MODE -->
    <template v-else-if="mode == 1">
      <b-row>
        <b-col cols="12" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
          <div class="number-sequence" :class="isFieldDisabled ? 'disable-question' : ''">
            <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
            <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
          </div>
          <span
            class="ml-2 question-tital-name"
            :class="isFieldDisabled ? 'disable-question' : ''"
            v-translate:_formattedBody="{
              key: translationKeyInitial,
              val: lang,
              html: componentData.formattedBody
            }"
            v-html="componentData.formattedBody"
          ></span>
          <span
            v-if="componentData.isSkippable"
            :class="isFieldDisabled ? 'disable-question' : ''"
            class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2"
            v-translate:_optional="{
              key: 'label',
              val: lang,
              html: 'Optional'
            }"
            >Optional</span
          >
          <div v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">
            Skipped
          </div>
          <span v-if="hasFieldError && !componentData.isSkippable" class="text-danger pl-5 fw-bold">{{ fieldErrorText }}</span>
          <span class="text-warning pl-5 fw-bold" v-else-if="hasFieldWarning">{{ fieldWarningText }}</span>
          <span v-else-if="hasFieldError && componentData.isSkippable" class="text-warning pl-5 fw-bold">{{ fieldErrorText }}</span>
        </b-col>
      </b-row>

      <b-row class="mb-10 mt-5 pl-43" :class="isFieldDisabled ? 'disable-question' : ''">
        <b-col cols="7" class="pl-0">
          <div class="log-entry-table-collapse">
            <table class="input-text table table-bordered log-entry-step-responsive" width="100%" border="0">
              <thead>
                <tr>
                  <th
                    v-for="(each, index) in componentData.entries"
                    v-translate="{
                      key: `${translationKeyInitial}_entries_${index}_header`,
                      val: lang,
                      html: each.header
                    }"
                    class="text-center"
                    :key="each.header"
                  >
                    {{ each.header }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in rows" :key="index">
                  <td class="m-0 p-0" v-for="(each, i) in componentData.entries" :key="i">
                    <b-form-input class="log-entry-form-input" @input="onFieldChange(index)" :maxlength="fieldCharacterLimit" :placeholder="each.label ? each.label : each.header" type="text" v-model="componentData.multiAnswer[index][i]" :name="'activityFormLogEntry_' + row + '_' + i" :class="{ 'is-danger': hasThisFieldError[index][i] }" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <button @click="addNewRow()" type="button" class="btn btn-md btn-block add_another_btn br-25 btn-new" :disabled="isFieldDisabled">
            <span class="circle">+</span
            ><span
              class="txt"
              v-translate:_add_row="{
                key: 'button',
                val: lang,
                html: 'Add a row'
              }"
              >Add a row</span
            >
          </button>
        </b-col>
        <b-col cols="5"> </b-col>
        <b-col cols="8"></b-col>
      </b-row>
      <div :class="isFieldDisabled ? 'disable-question' : ''">
        <span class="activity-form__clear pl-43" :class="{ clearOptionDisabled: isFieldDisabled }" v-translate:_CLEAR="{ key: 'BUTTON', val: lang, html: 'Clear' }" @click="clearAnswer">Clear</span>
        <div class="d-inline-block ml-18" v-if="activityInfo.canScoreResponses">
          <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }" class="fs-12">Score</label>
          <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
            {{ showScore(componentData.actualScore) }}
          </div>
        </div>
      </div>
    </template>

    <!-- RESPONSE MODE -->
    <template v-else-if="mode == 2">
      <span :class="{ 'query-icon': isEdited }"></span>
      <b-row>
        <b-col cols="10" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
          <div class="number-sequence">
            <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
            <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
          </div>
          <span
            class="ml-2 question-tital-name"
            v-translate:_formattedBody="{
              key: translationKeyInitial,
              val: lang,
              html: componentData.formattedBody
            }"
            v-html="componentData.formattedBody"
          ></span>
          <span
            class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2"
            v-translate:_optional="{
              key: 'label',
              val: lang,
              html: 'Optional'
            }"
            v-if="componentData.isSkippable && (isFieldDisabled == false || isFieldDisabled == undefined)"
            >Optional</span
          >
          <div v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">
            Skipped
          </div>
        </b-col>
        <b-col :class="componentData.isEditedVersion ? 'col-6' : 'col-10'" class="pl-30">
          <span class="changed" v-if="componentData.isEditedVersion"></span>
          <div class="answers ml-17">
            <table class="input-text table table-bordered" width="100%" border="0">
              <thead>
                <tr>
                  <th
                    class="text-center"
                    v-for="(each, index) in componentData.entries"
                    v-translate="{
                      key: `${translationKeyInitial}_entries_${index}_header`,
                      val: lang,
                      html: each.header
                    }"
                    :key="each.header"
                  >
                    {{ each.header }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in componentData.multiAnswer" :key="index">
                  <td class="m-0 p-0" v-for="(each, i) in row" :key="i">
                    <b-form-input disabled type="text" :value="each" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <b-row class="pt-5">
            <div class="d-inline-block ml-18" v-if="activityInfo.canScoreResponses">
              <label>Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.actualScore) }}
              </div>
              <!-- <span v-if="componentData.excludeScore" class="ml-10">Score excluded from total</span> -->
            </div>
          </b-row>
        </b-col>
        <b-col v-if="componentData.isEditedVersion" class="col-6 previous-answer">
          <span class="previous-value-mark"></span>
          <div
            class="answers previous-value"
            v-translate="{
              key: 'label_previous_value',
              val: lang,
              html: 'Previous value'
            }"
          >
            Previous value
          </div>
          <div>
            <table class="input-text table table-bordered" width="100%" border="0">
              <thead>
                <tr>
                  <th
                    class="text-center"
                    v-for="(each, index) in componentData.entries"
                    v-translate="{
                      key: `${translationKeyInitial}_entries_${index}_header`,
                      val: lang,
                      html: each.header
                    }"
                    :key="each.header"
                  >
                    {{ each.header }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in componentData.previousMultiAnswer" :key="index">
                  <td class="m-0 p-0" v-for="(each, i) in row" :key="i">
                    <b-form-input disabled type="text" :value="each" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <b-row class="pt-5" v-if="componentData.previousMultiAnswer">
            <div class="d-inline-block" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.previousActualScore) }}
              </div>
              <!-- <span v-if="componentData.excludeScore" class="ml-10">Score excluded from total</span> -->
            </div>
          </b-row>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import langTranslate from "./lang-translate";
import * as activityService from "../../services/activity-service";
export default {
  name: "activity-form-log-preview",

  mixins: [langTranslate],

  data() {
    return {
      fieldCharacterLimit: 35,
      hasFieldError: false,
      fieldErrorText: "",
      hasFieldWarning: false,
      fieldWarningText: "",
      hasThisFieldError: [],
      rows: 0
    };
  },

  props: {
    componentData: {},
    isDisplayQuestionInfo: {
      default: true
    },
    isFieldDisabled: {
      default: false
    },
    mode: {
      default: 0
    },
    isEdited: null,
    activityInfo: {
      default: () => {}
    },
    isNotificationIcon: Boolean,
    triggerValidate: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isFieldDisabled(val) {
      if (val === true) {
        this.resetField();
      }
    },
    hasFieldError(val) {
      this.componentData.hasFieldError = val;
    },
    fieldErrorText(val) {
      this.componentData.fieldErrorText = val;
    },
    triggerValidate() {
      let checkEmptyAns = false;
      if (!this.isFieldDisabled) {
        checkEmptyAns = activityService.checkLogEntryEmptyAnswers(this.componentData);
      }
      if (!this.isFieldDisabled && !this.componentData.isSkippable && ((!!this.componentData.multiAnswer && this.componentData.multiAnswer.length == 0) || checkEmptyAns)) {
        this.hasFieldError = true;
        this.fieldErrorText = "This field is required";
      }
      if (!this.isFieldDisabled && this.componentData.isSkippable && checkEmptyAns) {
        this.hasFieldError = true;
        this.fieldErrorText = "Please Fill Valid Data";
      }
    }
  },
  mounted() {
    if (this.componentData.hasOwnProperty("multiAnswer") && this.componentData.multiAnswer.length > 0) {
      this.rows = this.componentData.multiAnswer.length;
    } else {
      this.$set(this.componentData, "multiAnswer", []);
    }
    this.onFieldChange(null);
  },

  methods: {
    addNewRow() {
      if (!this.componentData.hasOwnProperty("multiAnswer")) {
        this.$set(this.componentData, "multiAnswer", []);
      }
      if (this.componentData.multiAnswer) {
        this.componentData.multiAnswer[this.rows] = [];
        this.onFieldChange(this.rows, null);
        this.rows += 1;
      }
    },
    showScore() {
      const ansArr = this.componentData.multiAnswer;
      if (ansArr) {
        if (ansArr.length > 0) {
          return 0;
        } else if (this.componentData.isSkippable && this.componentData.skipScore >= 0) {
          return this.componentData.skipScore;
        } else {
          return 0;
        }
      }
    },
    resetField() {
      this.rows = 0;
      this.componentData.multiAnswer = [];
      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;
      this.componentData.dataChecks = [];

      this.resetAllErrors();
      this.$emit("getQuestionScores");
    },
    clearAnswer() {
      this.resetField();
      this.$emit("onClearAnswer", this.componentData);
    },
    onFieldChange(index, x) {
      const hasThisFieldError = [];
      if (index != null) {
        const emptyFields =
          this.componentData.multiAnswer.length > 0
            ? this.componentData.multiAnswer[index].filter(c => {
                if (c == "" || c == null) {
                  return c;
                }
              })
            : [];

        if (x == null) {
          this.componentData.entries.forEach((c, i) => {
            hasThisFieldError[i] = !(this.componentData.multiAnswer[index].hasOwnProperty(i) && this.componentData.multiAnswer[index][i] !== "" && this.componentData.multiAnswer[index][i] !== null);
          });
          this.hasThisFieldError[index] = hasThisFieldError;
        } else {
          this.hasThisFieldError[index][x] = !(this.componentData.multiAnswer[index].hasOwnProperty(x) && this.componentData.multiAnswer[index][x] !== "" && this.componentData.multiAnswer[index][x] !== null);
        }

        this.$forceUpdate();

        if (emptyFields.length == this.componentData.multiAnswer[index].length) {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_required_all", `All fields are required.`);
          return true;
        }
      } else {
        this.componentData.multiAnswer.forEach((c, i) => {
          const rowErrors = [];
          c.forEach((cv, xi) => {
            rowErrors[xi] = !(cv !== "" && cv !== null);
          });
          hasThisFieldError[i] = rowErrors;
        });

        this.hasThisFieldError = hasThisFieldError;
      }

      this.checkForFieldErrors();
      this.onAnswerChange();
    },
    validateCharacterLimit(answer, hasLimit, characterLimit) {
      if (hasLimit && answer.length > characterLimit) {
        this.hasFieldError = true;

        this.fieldErrorText = this.translateToActiveLang("validation_error_char_limit", `Character limit can not be more than ${characterLimit}`, { CHAR_LIMIT: characterLimit });
        return true;
      }
      if (hasLimit == false && answer.length > 4096) {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_char_limit", `Character limit can not be more than 4096`, { CHAR_LIMIT: 4096 });
        return true;
      }
      return false;
    },
    resetAllErrors() {
      this.hasFieldError = false;
      this.fieldErrorText = "";
    },
    checkForFieldErrors() {
      let { multiAnswer, characterLimited, textLimit, isSkippable, answer, dataEditChecks } = this.componentData;
      this.componentData.dataChecks = [];
      this.resetAllErrors();

      if (dataEditChecks) {
        for (let k = 0; k < dataEditChecks.length; k++) {
          if (dataEditChecks[k].check == "SOFT") {
            if (dataEditChecks[k].type == "NOT_BLANK" && (multiAnswer == [] || answer == undefined || answer == "")) {
              this.hasFieldError = false;
              this.hasFieldWarning = true;
              this.fieldErrorText = "";
              this.fieldWarningText = `This field prefered to be filled.`;
              this.componentData.dataChecks.push({
                dataCheckId: dataEditChecks[k].id,
                dataCheckType: dataEditChecks[k].type,
                message: this.fieldWarningText
              });
              return false;
            }
          } else {
            if (dataEditChecks[k].type == "NOT_BLANK" && (multiAnswer == [] || answer == undefined || answer == "")) {
              this.hasFieldError = true;
              this.fieldErrorText = `This field is required.`;
              isSkippable = false;
            }
          }
        }
      }
      if (isSkippable && (multiAnswer == [] || answer == undefined)) {
        return;
      }

      multiAnswer.forEach(row => {
        if (row.length == this.componentData.entries.length) {
          row.forEach(column => {
            if (this.validateCharacterLimit(column, characterLimited, textLimit)) {
              return;
            }
          });
        } else {
          this.hasFieldError = true;
          this.fieldErrorText = this.fieldErrorText = this.translateToActiveLang("validation_error_required_all", `All fields are required.`);
        }
      });
    },
    onAnswerChange() {
      this.$nextTick(() => {
        this.componentData.computedScore = this.componentData.score;
        this.componentData.actualScore = this.componentData.score;
        this.$emit("onAnswerChange", this.componentData);
      });
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.changed {
  position: absolute;
  left: 0;
  top: 0;
  width: 10px;
  height: 60px;
  border-radius: 1px;
  background-color: #ffa200;
}

.previous-value-mark {
  width: 3px;
  height: 65px;
  background-color: #ffa200;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}
.answers {
  font-weight: 600;
}
.previous-answer {
  opacity: 0.8;
}
.previous-value {
  color: #ffa200;
  opacity: 0.8;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 9px;
  letter-spacing: 2.4px;
  margin-top: 3px;
}
.activity-form__clear {
  width: 29px;
  height: 14px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4c8ce4;
}
.btn-new {
  width: auto;
  height: 30px;
  background-color: #4c8ce4;
  border: none;
}
.add_another_btn {
  border-color: #4c8ce4;
  margin-bottom: 20px;
  background-color: #4c8ce4;
  font-size: 12px;
  line-height: 1.33;
  text-align: center;
  color: #ffffff;
}
.circle {
  width: 24px;
  height: 24px;
  background-color: #fff;
  position: relative;
  left: -11px;
  top: -3px;
  color: #4c8ce4;
  font-weight: bold;
  border-radius: 12px;
  font-size: 18px;
  padding: 0px 8px;
}
.txt {
  position: relative;
  color: #fff;
  left: -5px;
  top: -5px;
  font-size: 12px;
}
table.input-text th {
  background: #e4e8eb;
  padding: 7px;
  border-radius: 2px;
}

.table-bordered td {
  border: none;
}
.number-sequence {
  min-width: 30px;
  display: inline-block;
}
.form-control,
.form-control:disabled {
  border-radius: 0.1rem;
  background: #fff;
}
.component-div {
  border-top: 1px solid #fefefe;
  border-bottom: 1px solid #d3dfe4;
}
.cursor_pointer1 {
  cursor: pointer;
  width: 22px;
  height: 20px;
  border-radius: 4px;
  background-color: #c4c4c4;
  display: inline-block;
  color: #fff;
  text-align: center;
}
.log-entry-step-responsive {
  border-collapse: collapse !important;
  border-spacing: 0 !important;
  width: 100% !important;
}
.log-entry-table-collapse {
  overflow-x: auto !important;
}
.log-entry-form-input {
  width: -webkit-fill-available !important;
  width: -moz-available !important;
  height: 66px !important;
}
.clearOptionDisabled {
  pointer-events: none !important;
}
</style>
